export const emailjsConfig = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '',
  templates: {
    confirmed: process.env.REACT_APP_EMAILJS_CONFIRMED_TEMPLATE_ID || '',
  },
}
